module.exports = __webpack_public_path__ + "img/bh_9.31615b5c.jpg";